import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";

export class SetUnavailableSeatAction extends BaseAction<void, string[]> {

    override async run(): Promise<void | null> {
        try {
            updateRecoilState("unavailableSeatsAtom", this.params)
        } catch (error) {
            console.error("Error in SetUnavailableSeatAction:", error);
        }
    }
}

// Create a singleton instance
export const setUnavailableSeatAction = new SetUnavailableSeatAction(); 